import { render, staticRenderFns } from "./PercSensor.vue?vue&type=template&id=4c3a62e2&"
import script from "./PercSensor.vue?vue&type=script&lang=ts&"
export * from "./PercSensor.vue?vue&type=script&lang=ts&"
import style0 from "./PercSensor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports